export default "https://assets.pclncdn.com/web/next-landing/80a0a33/_next/static/images/Two-43f2bfbd4854c2d779530dca660b1708.svg";